import { styled } from "@mui/material";

export const Input = styled("input")({
  display: "none",
});
